export const fsaRebateDollar = {
  prefix: 'fsa',
  iconName: 'fsaRebateDollar',
  icon: [
    256,
    256,
    [],
    null,
    'M196.52066,232.72536c-3.57025,0-7.08951-1.64912-9.36766-4.74333  c-3.79128-5.151' +
      '37-2.6862-12.42789,2.48216-16.21915c39.01776-28.69804,51.95569-70.68251,36.45059' +
      '-118.20087  c-16.45717-50.41707-68.51485-79.46362-121.05707-67.71579c-6.24794,1.' +
      '4111-12.46188-2.52468-13.86448-8.78112  c-1.4026-6.25644,2.52467-12.46188,8.7811' +
      '2-13.86448c64.25604-14.46802,128.02756,21.31101,148.20798,83.15289  c18.59932,56' +
      '.97952,2.27817,109.51324-44.78116,144.11069C201.315,231.99431,198.90082,232.7253' +
      '6,196.52066,232.72536z   M197.81274,233.79643l41.78896-4.64133c6.37546-0.69705,1' +
      '0.96577-6.44347,10.25172-12.80191  c-0.69704-6.35844-6.47745-10.96577-12.8019-10' +
      '.25172l-41.78896,4.64133c-6.37546,0.69705-10.96577,6.44345-10.25172,12.80191  c0' +
      '.64604,5.93341,5.67839,10.33673,11.50981,10.33673C196.94569,233.88144,197.38773,' +
      '233.84743,197.81274,233.79643z   M208.14948,222.26961v-40.61586c0-6.40945-5.2023' +
      '6-11.61183-11.61182-11.61183s-11.61182,5.20238-11.61182,11.61183v40.61586  c0,6.' +
      '40945,5.20236,11.61183,11.61182,11.61183S208.14948,228.67906,208.14948,222.26961' +
      'z M153.69463,253.34781  c6.27345-1.29208,10.30273-7.44652,8.99364-13.71997c-1.30' +
      '91-6.27344-7.48053-10.33673-13.71997-8.99364  c-50.37457,10.45575-102.56825-19.8' +
      '064-118.94041-68.92287c-15.5306-46.6003-2.23566-89.65585,36.48458-118.12436  c5.' +
      '15987-3.79977,6.27345-11.05928,2.47368-16.22765c-3.81677-5.16837-11.05928-6.2734' +
      '5-16.22765-2.47367  c-47.37385,34.82697-63.6865,87.37769-44.74717,144.1702C25.58' +
      '207,221.79358,74.63053,256,128.03981,256  C136.51491,256,145.10902,255.13293,153' +
      '.69463,253.34781z M19.10461,50.41296l41.78046-4.64133  c6.36695-0.70555,10.95728' +
      '-6.44345,10.25172-12.81891c-0.71405-6.37545-6.52847-10.96577-12.8189-10.25172l-4' +
      '1.78046,4.64133  C10.17048,28.04788,5.58015,33.78578,6.2857,40.16123c0.66305,5.9' +
      '3342,5.6869,10.31973,11.51831,10.31973  C18.23755,50.48096,18.67108,50.46396,19.' +
      '10461,50.41296z M71.2473,74.85219V34.23631c0-6.40945-5.19387-11.60332-11.60332-1' +
      '1.60332  s-11.60332,5.19387-11.60332,11.60332v40.61588c0,6.40945,5.19387,11.6033' +
      '2,11.60332,11.60332S71.2473,81.26164,71.2473,74.85219z   M173.33102,152.63269c0-' +
      '20.18044-15.81113-35.98305-35.99155-35.98305h-19.7299c-6.16293,0-12.7679-5.13436' +
      '-12.7679-12.76791  c0-7.51453,5.25337-12.7679,12.7679-12.7679h20.89449c4.56482,0' +
      ',7.37001,1.76812,9.07013,5.73791  c2.53319,5.89091,9.41867,8.5856,15.23308,6.086' +
      '43c5.89943-2.53318,8.61961-9.35916,6.08644-15.25008  c-5.38939-12.57239-16.47417' +
      '-19.7809-30.38965-19.7809h-20.89449c-20.17193,0-35.97454,15.80262-35.97454,35.97' +
      '454  c0,19.84041,16.13414,35.97454,35.97454,35.97454h19.7299c7.52303,0,12.7679,5' +
      '.26189,12.7679,12.77641  c0,7.63354-6.59647,12.7509-12.7679,12.7509h-20.88599c-3' +
      '.28973,0-7.65904-2.95821-9.34216-6.34145  c-2.86471-5.72942-9.8777-8.09258-15.56' +
      '461-5.20238c-5.73791,2.8562-8.06707,9.82671-5.21087,15.5731  c5.6359,11.2888,18.' +
      '02128,19.19437,30.11763,19.19437h20.88599C157.17987,188.60724,173.33102,172.4731' +
      ',173.33102,152.63269z   M139.66014,79.51051V62.10128c0-6.40945-5.19388-11.60332-' +
      '11.60333-11.60332c-6.40945,0-11.60332,5.19387-11.60332,11.60332  v17.40923c0,6.4' +
      '0945,5.19387,11.60332,11.60332,11.60332C134.46626,91.11384,139.66014,85.91997,13' +
      '9.66014,79.51051z   M139.66014,195.57773v-18.56532c0-6.40944-5.19388-11.61182-11' +
      '.60333-11.61182c-6.40945,0-11.60332,5.20238-11.60332,11.61182  v18.56532c0,6.409' +
      '45,5.19387,11.61182,11.60332,11.61182C134.46626,207.18954,139.66014,201.98718,13' +
      '9.66014,195.57773z',
  ],
};
